
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tournaments/battles/[tournaments]",
      function () {
        return require("private-next-pages/tournaments/battles/[tournaments].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tournaments/battles/[tournaments]"])
      });
    }
  